import { render, staticRenderFns } from "./TagKeyword.vue?vue&type=template&id=7a0c226c"
import script from "./TagKeyword.vue?vue&type=script&lang=js"
export * from "./TagKeyword.vue?vue&type=script&lang=js"
import style0 from "./TagKeyword.vue?vue&type=style&index=0&id=7a0c226c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports